/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Filter } from "@mm-products/java-multima-framework";

export type TaxSubscriptionExportRequest = {
    filter: Filter;
    format: TaxSubscriptionExportRequest.format;
};

export namespace TaxSubscriptionExportRequest {
    export enum format {
        ZIP = "ZIP",
        XLSX = "XLSX",
    }
}
